import { AUDIO_PLAY_COMMAND } from '../../../stores/audioStore.js';

/**
 * Designer action-command schema. This is the single catalogue consumed by
 * the action parser, context resolver, editor and serializer.
 */
export const ACTION_COMMAND_SCHEMA = [
    {
        id: 'audio.stop',
        category: 'Audio',
        label: 'Stop playback',
        template: 'audio stop',
        parameters: [],
    },
    {
        id: 'audio.play',
        category: 'Audio',
        label: 'Play resource',
        template: AUDIO_PLAY_COMMAND,
        parameters: [],
    },
    {
        id: 'audio.volume',
        category: 'Audio',
        label: 'Set volume',
        template: 'audio volume {{value}}',
        parameters: [
            { id: 'value', label: 'Volume', type: 'expression', default: '{val}', scriptDefault: '50', variables: ['val'] },
        ],
        requiresVariables: ['val'],
    },
    {
        id: 'audio.file',
        category: 'Audio',
        label: 'Play file',
        template: 'audio {{path}}',
        parameters: [
            { id: 'path', label: 'File path', type: 'text', default: 'L:/', scriptDefault: 'L:/' },
        ],
    },
    ...[
        ['backlight.off', 'Display', 'Backlight off', 'backlight off'],
        ['backlight.on', 'Display', 'Backlight on', 'backlight on'],
        ['discovery', 'System', 'Run discovery', 'discovery'],
        ['restart', 'System', 'Restart', 'restart'],
        ['reboot', 'System', 'Reboot', 'reboot'],
        ['screenshot', 'System', 'Take screenshot', 'screenshot'],
        ['sensors', 'System', 'Publish sensors', 'sensors'],
        ['calibrate', 'System', 'Calibrate', 'calibrate'],
        ['factoryreset', 'System', 'Factory reset', 'factoryreset'],
        ['statusupdate', 'System', 'Update status', 'statusupdate'],
        ['idle.off', 'Display', 'Idle off', 'idle off'],
        ['idle.short', 'Display', 'Idle short', 'idle short'],
        ['idle.long', 'Display', 'Idle long', 'idle long'],
        ['page.next', 'Navigation', 'Next page', 'page next'],
        ['page.prev', 'Navigation', 'Previous page', 'page prev'],
        ['page.back', 'Navigation', 'Back', 'page back'],
        ['clearpage.all', 'Navigation', 'Clear all pages', 'clearpage all'],
    ].map(([id, category, label, template]) => ({ id, category, label, template, parameters: [] })),
    {
        id: 'page.goto',
        category: 'Navigation',
        label: 'Change page',
        template: 'page {{pageId}}',
        parameters: [
            { id: 'pageId', label: 'Page', type: 'page', default: '' },
        ],
    },
    {
        id: 'page.clear',
        category: 'Navigation',
        label: 'Clear page',
        template: 'clearpage{{pageId}}',
        parameters: [
            { id: 'pageId', label: 'Page', type: 'page', default: '' },
        ],
    },
];
